export default __webpack_public_path__ + "dec12db8ff1a2b8d4b63bec032d2eb09.png";